import { CircleCheck } from "lucide-react";
// import { Separator } from "@/components/ui/separator";

import {
  AppStoreButton,
  GooglePlayWhiteButton,
} from "@/components/store-buttons";
import { DOWNLOAD_LINK } from "@/lib/constants";
import type { VouchFeedbackProps } from "@/lib/types";

const FeedbackForPotentialUsers = ({
  vouchee,
  voucher,
}: VouchFeedbackProps) => {
  return (
    <div className="mx-auto flex w-full max-w-sm flex-col items-center gap-8 text-center">
      <div className="animate-support flex size-16 shrink-0 items-center justify-center rounded-full bg-muted">
        <CircleCheck
          className="size-7 text-muted-foreground"
          aria-hidden="true"
        />
      </div>
      <div className="flex flex-col gap-3">
        <h2 className="text-4xl text-foreground">
          {voucher?.meta?.Name?.trim().split(/\s+/)[0]},
        </h2>
        <p className="text-base leading-relaxed text-accent-foreground">
          Your words are now on {vouchee?.firstName}'s profile.
        </p>
        {voucher?.meta?.Relationship !== "parent" && (
          <p className="text-base leading-relaxed text-accent-foreground">
            Thinking about marriage?
          </p>
        )}
        {voucher?.meta?.Relationship !== "parent" && (
          <p className="text-base leading-relaxed font-bold text-accent-foreground">
            {vouchee?.firstName} can vouch for you too.
          </p>
        )}
        {voucher?.meta?.Relationship === "parent" && (
          <p className="text-base leading-relaxed text-accent-foreground">
            Any other children ready for marriage?
          </p>
        )}
        {voucher?.meta?.Relationship === "parent" && (
          <p className="text-base leading-relaxed font-bold text-accent-foreground">
            Set up their profile on Sakeena.
          </p>
        )}
        {/* <p className="text-sm leading-relaxed text-accent-foreground">
          On Sakeena, people looking for marriage are vouched for by those who know them.
        </p> */}
      </div>
      {/* <Separator /> */}
      <div className="flex flex-col items-center gap-3">
        <div className="flex flex-wrap justify-center gap-2">
          <AppStoreButton href={DOWNLOAD_LINK.APP_STORE_LINK} />
          <GooglePlayWhiteButton href={DOWNLOAD_LINK.PLAY_STORE_LINK} />
        </div>
        {/* <p className="text-xs text-muted-foreground/70">
          You can now close this page.
        </p> */}
      </div>
    </div>
  );
};

export default FeedbackForPotentialUsers;
